import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import { FetchError, GetTeamTaskItemsDto, queryKeys, useAccessToken } from "src/http";

const useGetTeamTaskItemsRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getTeamTaskItemsRequest({
    queryKey,
  }: QueryFunctionContext<ReturnType<typeof queryKeys.taskItems.getTeamTaskItems>>): Promise<GetTeamTaskItemsDto> {
    const accessToken = await getAccessToken();
    const [, teamSlug] = queryKey;

    const response = await fetch(`${configuration.apiRootUrl}/teams/${teamSlug}/task-items`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getTeamTaskItemsRequest };
};

const useGetTeamTaskItems = (teamSlug: string | undefined) => {
  const { getTeamTaskItemsRequest } = useGetTeamTaskItemsRequest();

  return useQuery({
    queryKey: queryKeys.taskItems.getTeamTaskItems(teamSlug),
    queryFn: getTeamTaskItemsRequest,
    enabled: teamSlug !== undefined,
  });
};

export { useGetTeamTaskItems };
